export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
                name: 'Div',
                attributes: { class: 'd-flex gap-16 d-sm-column' },
                components: [
                    {
                        type: 'itemTestimony5',
                    },
                    {
                        type: 'itemTestimony5',
                    },
                ],
                styles: `
                .gap-16{
                    gap: 16px; 
                }
                @media (max-width: 992px){
                    .d-sm-column{
                        flex-direction: column; 
                    }
                }
      
            `,
            },
        },
        view: {

        },
    };
    return component;
};